<template lang="html">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19.671"
    height="19.671"
    viewBox="0 0 19.671 19.671"
    aria-hidden="true"
  >
    <g
      id="streamline-icon-chat-translate_200x200"
      data-name="streamline-icon-chat-translate@200x200"
      transform="translate(-5.65 -5.65)"
    >
      <path
        id="Path_44642"
        data-name="Path 44642"
        d="M37.5,34.944V32.481a1.231,1.231,0,0,1,2.463,0v2.463"
        transform="translate(-28.172 -22.537)"
        fill="none"
        stroke="#fab62f"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.2"
      />
      <path
        id="Path_44643"
        data-name="Path 44643"
        d="M37.5,56.25h2.463"
        transform="translate(-28.172 -45.074)"
        fill="none"
        stroke="#fab62f"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.2"
      />
      <path
        id="Path_44644"
        data-name="Path 44644"
        d="M137.5,87.5v1.231"
        transform="translate(-118.32 -73.246)"
        fill="none"
        stroke="#fab62f"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.2"
      />
      <path
        id="Path_44645"
        data-name="Path 44645"
        d="M112.5,100h4.926"
        transform="translate(-95.783 -84.515)"
        fill="none"
        stroke="#fab62f"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.2"
      />
      <path
        id="Path_44646"
        data-name="Path 44646"
        d="M116.194,100s-1.231,3.694-3.694,3.694"
        transform="translate(-95.783 -84.515)"
        fill="none"
        stroke="#fab62f"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.2"
      />
      <path
        id="Path_44647"
        data-name="Path 44647"
        d="M137.5,123.058a3.228,3.228,0,0,0,2.463,1.423"
        transform="translate(-118.32 -105.301)"
        fill="none"
        stroke="#fab62f"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.2"
      />
      <path
        id="Path_44648"
        data-name="Path 44648"
        d="M82.481,77.37a1.231,1.231,0,0,1-1.231-1.231V69.981a1.231,1.231,0,0,1,1.231-1.231H91.1a1.231,1.231,0,0,1,1.231,1.231v6.157A1.231,1.231,0,0,1,91.1,77.37H89.87v3.694L86.175,77.37Z"
        transform="translate(-67.612 -56.343)"
        fill="none"
        stroke="#fab62f"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.2"
      />
      <path
        id="Path_44649"
        data-name="Path 44649"
        d="M11.176,16.1,8.713,18.564V14.87H7.481A1.231,1.231,0,0,1,6.25,13.638V7.481A1.231,1.231,0,0,1,7.481,6.25H16.1a1.231,1.231,0,0,1,1.231,1.231V9.944"
        transform="translate(0 0)"
        fill="none"
        stroke="#fab62f"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.2"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconSalesLanguages',
};
</script>
<style lang="scss" scoped>
.cls-1 {
  fill: none;
  stroke: #fa0;
  stroke-linecap: round;
  stroke-linejoin: round;
}
</style>
